import _regeneratorRuntime from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/regenerator';
import _Promise from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/promise';
import _Object$defineProperty from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/object/define-property';
import _Object$assign from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/object/assign';
import _extends from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/extends';
import _asyncToGenerator from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/helpers/asyncToGenerator';

var createApp = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ssrContext) {
    var _this = this;

    var router, store, app, next, route, path, inject;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            router = createRouter(ssrContext);
            store = createStore(ssrContext);
            // Add this.$router into store actions/mutations

            store.$router = router;

            // Create Root instance
            // here we inject the router and store to all child components,
            // making them available everywhere as `this.$router` and `this.$store`.
            app = _extends({
              router: router,
              store: store,
              nuxt: {
                defaultTransition: defaultTransition,
                transitions: [defaultTransition],
                setTransitions: function setTransitions(transitions) {
                  if (!Array.isArray(transitions)) {
                    transitions = [transitions];
                  }
                  transitions = transitions.map(function (transition) {
                    if (!transition) {
                      transition = defaultTransition;
                    } else if (typeof transition === 'string') {
                      transition = _Object$assign({}, defaultTransition, { name: transition });
                    } else {
                      transition = _Object$assign({}, defaultTransition, transition);
                    }
                    return transition;
                  });
                  this.$options.nuxt.transitions = transitions;
                  return transitions;
                },

                err: null,
                dateErr: null,
                error: function error(err) {
                  err = err || null;
                  app.context._errored = !!err;
                  if (typeof err === 'string') err = { statusCode: 500, message: err };
                  var nuxt = this.nuxt || this.$options.nuxt;
                  nuxt.dateErr = Date.now();
                  nuxt.err = err;
                  // Used in lib/server.js
                  if (ssrContext) ssrContext.nuxt.error = err;
                  return err;
                }
              }
            }, App);

            // Make app available into store via this.app

            store.app = app;

            next = ssrContext ? ssrContext.next : function (location) {
              return app.router.push(location);
            };
            // Resolve route

            route = void 0;

            if (ssrContext) {
              route = router.resolve(ssrContext.url).route;
            } else {
              path = getLocation(router.options.base);

              route = router.resolve(path).route;
            }

            // Set context to app.context
            _context2.next = 10;
            return setContext(app, {
              route: route,
              next: next,
              error: app.nuxt.error.bind(app),
              store: store,
              payload: ssrContext ? ssrContext.payload : undefined,
              req: ssrContext ? ssrContext.req : undefined,
              res: ssrContext ? ssrContext.res : undefined,
              beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined
            });

          case 10:
            inject = function inject(key, value) {
              if (!key) throw new Error('inject(key, value) has no key provided');
              if (!value) throw new Error('inject(key, value) has no value provided');
              key = '$' + key;
              // Add into app
              app[key] = value;

              // Add into store
              store[key] = app[key];

              // Check if plugin not already installed
              var installKey = '__nuxt_' + key + '_installed__';
              if (Vue[installKey]) return;
              Vue[installKey] = true;
              // Call Vue.use() to install the plugin into vm
              Vue.use(function () {
                if (!Vue.prototype.hasOwnProperty(key)) {
                  _Object$defineProperty(Vue.prototype, key, {
                    get: function get() {
                      return this.$root.$options[key];
                    }
                  });
                }
              });
            };

            if (process.browser) {
              // Replace store state before plugins execution
              if (window.__NUXT__ && window.__NUXT__.state) {
                store.replaceState(window.__NUXT__.state);
              }
            }

            // Plugin execution


            // If server-side, wait for async component to be resolved first

            if (!(process.server && ssrContext && ssrContext.url)) {
              _context2.next = 15;
              break;
            }

            _context2.next = 15;
            return new _Promise(function (resolve, reject) {
              router.push(ssrContext.url, resolve, function () {
                // navigated to a different route in router guard
                var unregister = router.afterEach(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            ssrContext.url = to.fullPath;
                            _context.next = 3;
                            return getRouteData(to);

                          case 3:
                            app.context.route = _context.sent;

                            app.context.params = to.params || {};
                            app.context.query = to.query || {};
                            unregister();
                            resolve();

                          case 8:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this);
                  }));

                  return function (_x2, _x3, _x4) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              });
            });

          case 15:
            return _context2.abrupt('return', {
              app: app,
              router: router,
              store: store
            });

          case 16:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function createApp(_x) {
    return _ref.apply(this, arguments);
  };
}();

import 'es6-promise/auto';
import Vue from 'vue';
import Meta from 'vue-meta';
import { createRouter } from './router.js';
import NoSSR from './components/no-ssr.js';
import NuxtChild from './components/nuxt-child.js';
import NuxtLink from './components/nuxt-link.js';
import NuxtError from './components/nuxt-error.vue';
import Nuxt from './components/nuxt.js';
import App from './App.js';
import { setContext, getLocation, getRouteData } from './utils';
import { createStore } from './store.js';

/* Plugins */

// Component: <no-ssr>
Vue.component(NoSSR.name, NoSSR);

// Component: <nuxt-child>
Vue.component(NuxtChild.name, NuxtChild);

// Component: <nuxt-link>
Vue.component(NuxtLink.name, NuxtLink);

// Component: <nuxt>`
Vue.component(Nuxt.name, Nuxt);

// vue-meta configuration
Vue.use(Meta, {
  keyName: 'head', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-n-head', // the attribute name vue-meta adds to the tags it observes
  ssrAttribute: 'data-n-head-ssr', // the attribute name that lets vue-meta know that meta info has already been server-rendered
  tagIDKeyName: 'hid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
});

var defaultTransition = { "name": "page", "mode": "out-in", "appear": false, "appearClass": "appear", "appearActiveClass": "appear-active", "appearToClass": "appear-to" };

export { createApp, NuxtError };


//////////////////
// WEBPACK FOOTER
// ./.nuxt/index.js
// module id = ./.nuxt/index.js
// module chunks = 18